import { crmApiInstance } from './client.js';

export const orderImportApi = {
  upload: (file, onProgress, forceStatus) => {
    const form = new FormData();
    form.append('file', file);
    if (forceStatus) form.append('force_status', forceStatus);
    return crmApiInstance.post('/admin/order-import', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300_000, // 5 min — large files can take time
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    });
  },
};
